import React, {useEffect, useMemo, useState} from 'react';
import {useStore} from "../../../../stores/StoreHelpers";
import {NavLink, useHistory, useParams} from "react-router-dom";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {ArticlesRequests} from "../../../../requests/PortfolioRequests/articlesRequests";
import useAPI from "../../../../hooks/useAPI";
import useToast from "../../../../hooks/useToast";
import style from "../../../../components/project/Widgets/Articles/style.module.less";
import LinkTableComponent from "../../../../components/LinkTableComponent/LinkTableComponent";
import FileTableComponent from "../../../../components/FileTableIcon/FileTableComponent";
import StatusBadge from "../../../../components/common/StatusBadge";
import MaterialTable, {MTableAction, MTableBody} from "material-table";
import {
    getStickyActionAndStatus,
    LocalizationWithSmallActions,
    modifyDefaultOptions,
    objectToCols, styledHeaderSticky, arrayToLookup, mapFilesForModal
} from "../../../../helpers/table";
import {newYears, tableIcons, years} from "../../../../helpers";
import MTableHeader from "../../../../components/material-table-overrides/MTableHeader";
import {MTableToolbar } from 'material-table';

import {ThreeDRotation} from "@material-ui/icons";
import useUserContext from "../../../../hooks/useUserContext";
import {FileView} from "../../../../components/UI/upload/FileInput";
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import ModalDescription from "../../../../components/common/ModalDescription";
import {observer} from "mobx-react";
import SlicedTableColumn from "../../../../components/strategyProject/tabs/TabResults/SlicedTableColumn";
import DownloadLink from "../../../../components/common/DownloadLink";
import SelectInput from "../../../../components/SelectInput/SelectInput";
import moment from "moment";
import TooltippedElement from "../../../../components/common/TooltippedElement";
import {isAdmin, isPortfolioTeam, isProjectTeam} from "../../../../services/rolesSvc";
import ModalSendForRevision from "../../../../components/common/ModalSendForRevision";
import ConfirmModal from "../../../../components/common/ConfirmModal";
import RegisterFilterRow from "../../../../components/RegisterFilterSection/RegisterFilterRow";
import RegisterFilterSelectorGroup from "../../../../components/RegisterFilterSection/RegisterFilterSelectorGroup";
import {status_ru} from "../../../../helpers/PortfolioProject/ArticlesHelper";
import SpinnerComponent from "../../../../components/SpinnerComponent/SpinnerComponent";
import HintCard from "../../../../components/common/HintCard/HintCard";
import FilterMultiSelect from '../../../../components/table/FilterMultiSelect';

const stickyCellStyle = {
    background: 'inherit',
    position: 'sticky',
    left: 0,
    zIndex: 11,
}

const ArticlesTable = observer(({navCtx, portfName}) => {
    const {stratId, portfolioId} = useParams()
    const api = useAPI()
    const addToast = useToast()
    const store = useStore()
    const userCtx = useUserContext()
    const history = useHistory()

    const [filesModalOpen, setFilesModalOpen] = useState(null)
    const [resultModalOpen, setResultModalOpen] = useState(null)
    const [currentDataSet, setDataSet] = useState([])
    const [isLoaded, setIsLoading] = useState(false)
    const optionsResultsYear = [{value: 'null', label: 'Не указан'}, ...newYears.map((val, index) => {
        return {value: val, label: val}
    })]
    const optionsArticlesStatus = [{value:null,label:'Не указан'},...Object.entries(status_ru).map((val, index)=> {
        return {value:val[0],label:val[1]}
    })]
    const editable = useMemo(() => isAdmin(userCtx) || isPortfolioTeam(userCtx, portfolioId), [userCtx]);

    const requests = useRequestObject({classType:ArticlesRequests,api,addToast,store,portfolioId})
        const fetchData = () =>
        new Promise(resolve => {
            setIsLoading(false)
            resolve()
        }).then(() =>
            requests.getAllPortfolioArticles())
            .then(() => updateTableData())
            .then(() => setIsLoading(true))

    const updateTableData = () => {
        setDataSet(store.articles?.allArticles?.data.map(x => {
            return {
                ...{
                    isPriorityFinSourceString:x.isPriorityFinSource ? 'Да' : 'Нет',
                    highlyCitedPaperString:x.highlyCitedPaper ? 'Да' : 'Нет',
                    headName: x?.proj?.head?.displayName,
                    projName: `${x?.proj?.fullNumber} ${x?.proj?.name}`
                }
                , ...x
            }

        })?.slice()?.reverse());
    };

    useEffect(() => {
        fetchData()
    }, [])

    const [isModalDelete, setIsModalDelete] = useState({
        show: false,
        value: null,
    });
    const [isModalReject, setIsModalReject] = useState({
        show: false,
        value: null,
    });

    const handleReject = async (comment) => {
        await requests.rejectArticle(isModalReject.value, comment);
        updateTableData();
        setIsModalReject({show: false, value: null});
    }
    const handleDelete = async () => {
        await requests.deleteArticleById(isModalDelete.value).then(() => history.push(`/strats/${stratId}/portfolios/${portfolioId}/report/articles`));
        updateTableData();
        setIsModalDelete({show: false, value: null});
    };

    const actions = {
        edit: (id, rowData) => {
            store.articles.setResultObject(rowData);
            history.push(`/strats/${navCtx.strategy.id}/portfolios/${portfolioId}/projs/${rowData?.projId}/report/articles/${id}`)
        },
        send: async (id) => {
            await requests.sendArticle(id);
            updateTableData();
        },
        approve: async (id) => {
            await requests.approveArticle(id);
            updateTableData();
        },
        reject: async (id) => setIsModalReject({show: true, value: id}),
        delete: async (id) => setIsModalDelete({show: true, value: id}),
    };


    const getColumns = () => {
        const articleAuthors = [
            {
                title: 'Авторы из команды', field: 'teamMembers',
                width: '270px',
                render: (rowData) => <div>{!!rowData?.teamMembers?.length && rowData.teamMembers.map(x => <p
                    className={style.authorsCol}>{x?.lastName} {x?.firstName} {x?.middleName}</p>)}</div>,
                customFilterAndSearch: (term, rowData) => {
                    let authors = rowData.teamMembers.reduce(
                      (prev, cur) => (prev += cur.lastName + cur.firstName + cur.middleName),
                      ""
                    );
                    authors=authors.toLowerCase()
                    return authors.includes(term.toLowerCase());
                  },

            },
            {
                title: 'Авторы статьи', field: 'authors',
                width: '270px',
                render: (rowData) => <div>{!!rowData?.authors?.length && rowData.authors.map(x =>
                    <p className={style.authorsCol}>{x?.lastName} {x?.firstName} {x?.middleName}</p>)}</div>,
                customFilterAndSearch: (term, rowData) => {
                    let authors = rowData.authors.reduce(
                      (prev, cur) => (prev += cur.lastName + cur.firstName + cur.middleName),
                      ""
                    );
                    authors=authors.toLowerCase()
                    return authors.includes(term.toLowerCase());
                  },

            },
        ]
        const smallCols = [
            {title: 'Название журнала', field: 'journalName', width: '100px', lookup: arrayToLookup("journalName", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: '№ выпуска журнала', field: 'issue', width: '100px', lookup: arrayToLookup("issue", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: 'Квартиль журнала WOS', field: 'quartileWos', width: '100px', lookup: arrayToLookup("quartileWos", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: 'Квартиль журнала Scopus', field: 'quartileScopus', width: '100px', lookup: arrayToLookup("quartileScopus", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: 'Год учета статьи', field: 'year', width: '100px', lookup: arrayToLookup("year", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: 'Год публикации статьи', field: 'publishYear', width: '100px', lookup: arrayToLookup("publishYear", currentDataSet),filterComponent: FilterMultiSelect,},
            {title: '№ тома', field: 'volume', width: '100px'},
            {title: '№ страниц', field: 'pp', width: '100px'},
        ]
        const articleIds = [
            {title: 'ID Scopus', field: 'scopusId', width: '150px'},
            {title: 'ID WOS', field: 'wosId', width: '150px'},
            {title: 'DOI', field: 'doi', width: '330px'},
            {title: 'ID Pure', field: 'pureId', width: '330px'},
        ]
        const smallLastCols = [
            {
                title: 'Ссылка на статью БД', field: 'linkNote',
                width: '120px',
                render: (rowData => <LinkTableComponent link={rowData?.linkNote}/>)

            },
            {
                title: 'Сведения о финансир.', field: 'bibliographicNote',
                width: '350px',
                render: (rowData) => <SlicedTableColumn text={rowData?.bibliographicNote}
                                                        onClick={() => setResultModalOpen(rowData?.bibliographicNote)}
                                                        length={80}/>

            },
            {
                title: 'Высокоцитируемая публикация', field: 'highlyCitedPaperString',
                width: '5%',
                lookup: arrayToLookup("highlyCitedPaperString", currentDataSet),
                filterComponent: FilterMultiSelect,

            },
            {
                title: 'Поддержка из средств Приоритет', field: 'isPriorityFinSourceString',
                width: '5%',
                lookup: arrayToLookup("isPriorityFinSourceString", currentDataSet),
                filterComponent: FilterMultiSelect,

            },
            {
                title: 'Подтв. документ', field: 'file',
                render: (rowData) => rowData?.file
                    ? <FileTableComponent data={1}
                                          onClick={() => !!rowData?.file && setFilesModalOpen(rowData.file)}/>
                    : <FileTableComponent data={0}/>,
                width: '5%',
                maxWidth: '5%'
            },
        ]


        const firstCols = [
            ...getStickyActionAndStatus(actions, userCtx, stratId, portfolioId, 'article'),
            {
                title: '№ и Название проекта', field: 'projName',

                filtering: true,
                sorting: true,
                width: '270px',
                lookup: arrayToLookup("projName", currentDataSet),
                filterComponent: FilterMultiSelect,
            },
            {
                title: 'Руководитель проекта', field: 'headName',
                filtering: true,
                sorting: true,
                width: '270px',
                lookup: arrayToLookup("headName", currentDataSet),
                filterComponent: FilterMultiSelect,
            },
            {
                title: 'Название статьи',
                field: 'articleName',

                filtering: true,
                sorting: true,
                render: (rowData) => <NavLink onClick={() => store.articles.setResultObject(rowData)}
                                              to={`/strats/${navCtx.strategy.id}/portfolios/${portfolioId}/projs/${rowData?.projId}/report/articles/${rowData.id}`}>{rowData?.articleName}</NavLink>,
                width: '250px'

            },
            ...articleAuthors,
            ...smallCols,
            ...articleIds,
            ...smallLastCols
        ]
        return firstCols
    }
    const selectors = (
        <RegisterFilterRow
            buttonCreatorObject={[
                {
                    title: 'Выгрузить в xls',custom:(
                        <DownloadLink variant="outline-primary"
                                      url={`/factdata/articles/0/export?portfId=${portfolioId}${!!store.articles.filters?.year ?`&year=${store.articles.filters?.year}` : ''}`}
                                      filename={`Статьи портфель проектов (${portfName})_${moment().format('DD.MM.YYYY')}.xlsx`}>
                        Выгрузить в xls
                        </DownloadLink>
                    )
                },
                // {title: 'Выгрузить в xls', custom:(<div>12345</div>)}
            ]}>
            <RegisterFilterSelectorGroup
                selectors={[
                    {
                        label: 'Год',
                        minWidth:144,
                        selectorOptions: {
                            defaultValue: optionsResultsYear[0],
                            defaultOptions: optionsResultsYear,
                            value: !store.articles.filters['year'] ? optionsResultsYear[0] : {
                                value: store.articles.filters['year'],
                                label: store.articles.filters['year']
                            },
                            onChange: (e) => {
                                store.articles.changeFilter(`year`, e.value)
                                    .then(()=>requests.getAllPortfolioArticles())
                                    // .then(()=>{
                                    //     const filtered = getFilteredResult()
                                    //     return store.art icles.updateAllArticles({data:filtered,count:filtered.length})
                                    // })
                                    .then(()=>updateTableData())
                            }
                        }
                    },
                    {
                        label: 'Статус',
                        minWidth:170,
                        selectorOptions: {
                            defaultValue: optionsArticlesStatus[0],
                            defaultOptions: optionsArticlesStatus,
                            value:!store.articles.filters['status'] ? optionsArticlesStatus[0] : {value:store.articles.filters['status']?.value,label:store.articles.filters['status']?.label},
                            onChange: (e) => {
                                store.articles.changeFilter(`status`, e)
                                    .then(()=>requests.getAllPortfolioArticles())
                                    // .then(()=>{
                                    //     const filtered = getFilteredResult()
                                    //     return store.articles.updateAllArticles({data:filtered,count:filtered.length})
                                    // })
                                    .then(()=>updateTableData())
                            }
                        }
                    },
                ]}></RegisterFilterSelectorGroup>
        </RegisterFilterRow>
    )

    const articleTable = useMemo(()=> {
    return (
        <>
            <MaterialTable
                title=""
                options={modifyDefaultOptions({
                    padding: 'default',
                    filtering: true,
                    sorting: true,
                    search: false,
                    toolbar: true,
                    tableLayout: 'auto',

                    maxBodyHeight: 'calc(100vh - 376px)',
                    headerStyle: {
                        fontSize: '12px',
                        zIndex: 0
                    },
                    filterCellStyle: {
                        position: "sticky",
                        background: 'white',
                    }
                })}
                columns={objectToCols(getColumns())}
                data={currentDataSet ?? []}
                localization={LocalizationWithSmallActions}
                icons={tableIcons}
                components={{
                    Container: (props) => <div className={'special-filter-without-max'} {...props}/>,
                    Toolbar:(props)=>(
                        <div className={'d-flex justify-content-between'}>
                            <div style={{marginBottom:'2rem'}}>
                                {selectors}
                            </div>
                            <MTableToolbar {...props}/>
                        </div>
                    ),
                    Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}/>),
                    Body: (props) => (
                        <>
                            <MTableBody {...props}/>
                            <div id="portal-root"></div>
                        </>
                    ),

                }}

            />
        </>)
},[currentDataSet, portfolioId])

const getFilesForModal = () => {
    const files = [filesModalOpen]
    return mapFilesForModal(files,`Подтверждающий документ`)
    // return (
    //     <div className={'mt-lg-2'}>
    //         <h3 style={{fontWeight: 600}}>{`Подтверждающий документ`}</h3>
    //         <div className={'mt-lg-4'}>
    //             {!!files.length ? files.map((x, y) => <FileView disabled={true} isDownloadable={true} item={x}
    //                                                             index={y}/>) :
    //                 <span className={style.noFiles}>—</span>}
    //         </div>
    //     </div>
    // )
}

return (
    <div>
        <HintCard
            cardStyles={{fontSize: '18px',marginTop:0,fontsize:'18px'}}
            noGutter={true}
            rowStyles={{padding:0,margin:'auto',marginBottom:'1em'}}
            text={"Для добавления статей/доходов/заявок в проект, убедитесь, что заполнен реестр «Участники»"}
        />
            {isLoaded ?
                <div className={style.tableWrapper}>
                    {articleTable}
                </div>
                : <SpinnerComponent/>
            }
            {<ModalDescription headerText={'Приложенный документ'} onClose={() => setFilesModalOpen(!filesModalOpen)}
                               show={filesModalOpen}>
                <Container>
                    {getFilesForModal()}
                </Container>
            </ModalDescription>}
            {<ModalDescription className={style.modalDescription} headerText={'Подробное описание'}
                               onClose={() => setResultModalOpen(null)} show={!!resultModalOpen}>
                <Container>
                    <span>{resultModalOpen || ''}</span>
                </Container>
            </ModalDescription>}
            <ModalSendForRevision
                show={isModalReject.show}
                onClose={() => setIsModalReject({ show: false, value: null })}
                onSubmit={(comment) => handleReject(comment)}
                headerText="Не согласовать"
                label="Комментарий"
            />
            <ConfirmModal
                show={isModalDelete.show}
                onClose={() => setIsModalDelete({ show: false, value: null })}
                onConfirm={() => handleDelete()}
                headerText="Удаление статьи"
                message="Статья будет удалена, данное действие нельзя отменить. Удалить статью?"
        />
    </div>
);
})
;

export default ArticlesTable;
